// extracted by mini-css-extract-plugin
module.exports = {"container":"FromToPicker_container__3KbLp","text":"FromToPicker_text__22MDC"};